// lang/en.js
export default {
  copySuccess: "Copy successful",
  copyFail: "Copy fails, please try to copy manually",
  foot: {
    termsOfService: "Terms of Service",
    privacyPolicy: "Privacy Policy",
    Notice: "Notice",
    EmailText: "GM Email：",
    info: "c",
    info1: "",
    info2: "",
    info3: "",
    info4: "",
    rotwilightsea:
      "© Gravity Co., LTD & Lee MyoungJin(studio DTDS). All Rights Reserved.",
  },
  notFound: {
    title: "The page you are trying to access is not found......",
    content:
      "Leaving this page soon,  Will return to the homepage automatically in ",
    content2: " seconds",
    btn: "Back to homepage",
  },
};
